import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronTriangleRightMedium: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chevron-triangle-right-medium, dropdown, caret"><path d="M9 6.74978C9.00007 6.4583 9.16939 6.19321 9.43359 6.07009C9.69775 5.94715 10.0093 5.98818 10.2324 6.17556L16.4824 11.4256C16.652 11.568 16.7499 11.7783 16.75 11.9998C16.75 12.2213 16.652 12.4315 16.4824 12.574L10.2324 17.824C10.0093 18.0115 9.6978 18.0525 9.43359 17.9295C9.16937 17.8063 9 17.5413 9 17.2498V6.74978Z" fill="currentColor"/></CentralIconBase>;
};

export default IconChevronTriangleRightMedium;
